export default __webpack_public_path__ + "static/media/fraction.2a1a8644.svg";